import ChartWidget from '../components/widgets/ChartWidget';

export default function ChartDemo() {
  // Dados de exemplo
  const lineData = [
    { name: 'Jan', value: 400 },
    { name: 'Fev', value: 300 },
    { name: 'Mar', value: 600 },
    { name: 'Abr', value: 800 },
    { name: 'Mai', value: 500 },
    { name: 'Jun', value: 700 },
  ];

  const barData = [
    { name: 'Segunda', value: 120 },
    { name: 'Terça', value: 200 },
    { name: 'Quarta', value: 150 },
    { name: 'Quinta', value: 280 },
    { name: 'Sexta', value: 390 },
  ];

  const pieData = [
    { name: 'Produto A', value: 400 },
    { name: 'Produto B', value: 300 },
    { name: 'Produto C', value: 200 },
    { name: 'Produto D', value: 100 },
  ];

  const areaData = [
    { name: 'Jan', value: 4000 },
    { name: 'Fev', value: 3000 },
    { name: 'Mar', value: 2000 },
    { name: 'Abr', value: 2780 },
    { name: 'Mai', value: 1890 },
    { name: 'Jun', value: 2390 },
  ];

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-7xl mx-auto space-y-8">
        <div>
          <h1 className="text-4xl font-bold mb-2">Demonstração de Charts</h1>
          <p className="text-muted-foreground">
            Exemplos de todos os tipos de gráficos disponíveis usando shadcn/ui
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Line Chart */}
          <div className="h-[400px]">
            <ChartWidget
              title="Gráfico de Linha"
              description="Vendas ao longo do tempo"
              type="line"
              data={lineData}
              xKey="name"
              yKey="value"
            />
          </div>

          {/* Bar Chart */}
          <div className="h-[400px]">
            <ChartWidget
              title="Gráfico de Barras"
              description="Vendas por dia da semana"
              type="bar"
              data={barData}
              xKey="name"
              yKey="value"
            />
          </div>

          {/* Area Chart */}
          <div className="h-[400px]">
            <ChartWidget
              title="Gráfico de Área"
              description="Receita mensal"
              type="area"
              data={areaData}
              xKey="name"
              yKey="value"
            />
          </div>

          {/* Pie Chart */}
          <div className="h-[400px]">
            <ChartWidget
              title="Gráfico de Pizza"
              description="Distribuição de produtos"
              type="pie"
              data={pieData}
              xKey="name"
              yKey="value"
            />
          </div>

          {/* Donut Chart */}
          <div className="h-[400px]">
            <ChartWidget
              title="Gráfico Donut"
              description="Categorias de vendas"
              type="donut"
              data={pieData}
              xKey="name"
              yKey="value"
            />
          </div>

          {/* Gauge Chart */}
          <div className="h-[400px]">
            <ChartWidget
              title="Medidor (Gauge)"
              description="Performance atual"
              type="gauge"
              data={[{ name: 'Performance', value: 75 }]}
              xKey="name"
              yKey="value"
            />
          </div>

          {/* Radial Bar Chart */}
          <div className="h-[400px]">
            <ChartWidget
              title="Gráfico Radial"
              description="Metas atingidas"
              type="radialBar"
              data={[
                { name: 'Meta 1', value: 85 },
                { name: 'Meta 2', value: 70 },
                { name: 'Meta 3', value: 90 },
              ]}
              xKey="name"
              yKey="value"
            />
          </div>

          {/* Scatter Chart */}
          <div className="h-[400px]">
            <ChartWidget
              title="Gráfico de Dispersão"
              description="Correlação entre variáveis"
              type="scatter"
              data={[
                { name: 10, value: 30 },
                { name: 20, value: 50 },
                { name: 30, value: 45 },
                { name: 40, value: 80 },
                { name: 50, value: 75 },
                { name: 60, value: 90 },
              ]}
              xKey="name"
              yKey="value"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
